import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'https://lionfish-app-4t7wu.ondigitalocean.app',
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('pe_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('pe_token')
      window.location.href = '/login'
    }
    return Promise.reject(err)
  }
)

export default api
